(function(){
  function listenLogo(){
    var button = document.getElementsByClassName('logo-frame')[0]
    button.addEventListener('click',function(){
      window.location.href='#index'
    })
  }
  listenLogo()
})()